import { components, ClearIndicatorProps } from 'react-select';

import { Icon } from 'components/icon';

type Props = ClearIndicatorProps<any>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ClearIndicator = ({ children, ...props }: Props) => {
  return components.ClearIndicator({
    ...props,
    children: <Icon.CloseCircle className="close-circle-icon" />,
  });
};
